<template>

	<v-row>
		<v-col>
			<v-form
					v-model="formIsValid.inviteDetails"
					ref="inviteDetailsForm"
					class="mb-8"
			>
				<ui-box eager :form="$refs.inviteDetailsForm" new-forms>
					<v-row>
						<v-col>
							<div
									class="align-center field-actions d-flex justify-end">

								<div
										class="grey--text ms-2 text-caption text--darken-1"
								>
									<template v-if="isGeneratingDescription">
										This may take a couple seconds.
									</template>
									<template v-else>
										Regenerate Message
									</template>
								</div>
								<v-btn
										aria-label="Regenerate Message"
										icon
										:loading="isGeneratingDescription"
										@click="regenerateDescriptionDialog"
								>
									<v-icon
											key="autogen-on"
											color="secondary"
									>
										mdi-autorenew
									</v-icon>
								</v-btn>
							</div>
							<v-textarea
									v-model="localCampaigns[0].description"
									auto-grow
									class="rounded-lg required"
									counter="2000"
									hint="Provide information about the pass and why your local businesses should participate"
									label="Invite Message"
									outlined
									persistent-hint
									rows="4"
									:rules="rules.description"
							></v-textarea>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>
			<v-row v-if="showPeriodSelector" class="mb-8">
				<v-col cols=“12” md="6">
					<v-select
							v-model="globalPeriod"
							class="rounded-lg"
							clearable
							hide-details="auto"
							:items="periodItems"
							label="Delay Period"
							outlined
							required
							:rules="rules.period"
					></v-select>
				</v-col>
			</v-row>
		  <v-form v-model="formIsValid.viewCampaignEmails0" ref="viewCampaignEmailsForm0" class="mb-8">
				<sequence-form
						:description="dripSequenceDescriptions[0]"
						:firstInterval="dripSequenceFirstIntervals[0]"
						:form-is-valid="formIsValid"
						form-ref="viewCampaignEmailsForm0"
						ignore-first-interval
						:loading="dripSequencesLoading"
						:period="globalPeriod"
						:sequence="localDripSequencesPreview[0]"
						:title="dripSequenceTitles[0]"
						@active-change="(idx, active) => saveActiveChange(0, idx, active)"
						@add-message="addMessage(0)"
						@edit-message="idx => editMessage(0, idx)"
						@show-message-preview="showMessagePreview"
						@send-test="sendTest(0)"
				/>
      </v-form>
			<v-form v-model="formIsValid.viewCampaignEmails1" ref="viewCampaignEmailsForm1" class="mb-8">
				<sequence-form
						:description="dripSequenceDescriptions[1]"
						:firstInterval="dripSequenceFirstIntervals[1]"
						:form-is-valid="formIsValid"
						form-ref="viewCampaignEmailsForm1"
						:loading="dripSequencesLoading"
						:period="globalPeriod"
						:sequence="localDripSequencesPreview[1]"
						:title="dripSequenceTitles[1]"
						@active-change="(idx, active) => saveActiveChange(1, idx, active)"
						@add-message="addMessage(1)"
						@edit-message="idx => editMessage(1, idx)"
						@show-message-preview="showMessagePreview"
						@send-test="sendTest(1)"
				/>
			</v-form>
			<div class="d-flex justify-end">
				<v-btn
						class="rounded-lg"
						color="grey darken-1"
						depressed
						text
						@click="exit"
				>
					Cancel
				</v-btn>
				<v-btn
						class="ms-2 ms-md-4 rounded-lg"
						color="primary"
						depressed
						@click="doContinue"
				>
					Continue
				</v-btn>
			</div>
			<v-dialog
					v-model="dialog.message"
					content-class="rounded-xl"
					persistent
					scrollable
					width="1000px"
			>
				<v-form v-model="formIsValid.message" ref="formMessage">
					<v-card class="email-preview position-relative" rounded="xl">
						<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
							<div class="w-100">
								<div class="align-center d-flex justify-space-between">
									<h6>
										{{ editingMessage.sequenceIdx !== null ? 'New ' : '' }}
										Email
										{{ editingMessage.isPreview ? ' Preview' : ' Settings' }}
									</h6>
									<v-btn
											class="mt-n1 me-n2"
											color="black"
											depressed
											icon
											@click="hideMessagePreview"
									>
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</div>
							</div>
						</v-card-title>
						<v-card-text class="text-body-2">
							<v-row>
								<v-col>
									<div
											v-if="editingMessage.isPreview"
											v-text="editingMessage.subject"
											class="subtitle-2"
									></div>
									<v-text-field
											v-else
											v-model="editingMessage.subject"
											class="rounded-lg"
											hide-details="auto"
											label="Subject"
											outlined
											:rules="rules.email_subject"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<div
											v-if="editingMessage.isPreview"
											v-html="editingMessage.message.replace(/\n/g, '<br>')"
									></div>
									<v-textarea
											v-else
											v-model="editingMessage.message"
											class="rounded-lg"
											hide-details="auto"
											label="Message"
											outlined
											rows="12"
											:rules="rules.message"
											type="text"
									></v-textarea>
								</v-col>
							</v-row>
							<v-row
									v-if="
										!editingMessage.isPreview &&
										(
											editingMessage.dripIdx !== 0 ||
											editingMessage.sequenceIdx !== 0
										)
									" 
							>
								<v-col cols=“12” md="6">
									<v-text-field
										v-model="editingMessage.delta"
										class="rounded-lg"
										hide-details="auto"
										:label="periodLabel"
										outlined
										type="number"
										:rules="rules.delay"
									></v-text-field>
								</v-col>
							</v-row>
						</v-card-text>

						<v-card-actions v-if="!editingMessage.isPreview" class="d-block">
							<save-form
									:additional-validations="[ formIsValid.message ]"
									:refs="$refs"
									:is-saving="isSaving"
									new-forms
									save-text="Save"
									@cancel-action="hideMessagePreview"
									@save-action="save"
							></save-form>
						</v-card-actions>
					</v-card>
				</v-form>
			</v-dialog>
			<v-dialog
					v-model="dialog.sendTest"
					content-class="rounded-xl"
					persistent
					scrollable
					width="433px"
			>
				<v-card class="email-preview send-test position-relative" rounded="xl">
					<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
						<div class="w-100">
							<div class="align-center d-flex justify-space-between">
								<h6>Test {{ dripSequenceTitles[testingCampaign.idx] }}</h6>
								<v-btn
										class="mt-n1 me-n2"
										color="black"
										depressed
										icon
										@click="dialog.sendTest = false"
								>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</div>
						</div>
					</v-card-title>
					<v-card-text class="text-body-2">
						<v-row>
							<v-col>
								<div v-html="user.email"></div>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions class="d-block">
						<save-form
								:refs="$refs"
								:is-saving="isSaving"
								isValidText=""
								new-forms
								save-text="Send"
								@cancel-action="dialog.sendTest = false"
								@save-action="doSendTest"
						></save-form>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<confirm-dialog
					:open="dialog.sendTestSuccess"
					description="Email sequence test completed successfully."
					dismissable
					title="Success"
					@dismiss="dialog.sendTestSuccess = false"
			></confirm-dialog>
			<confirm-dialog
					:open="dialog.regenerateDescription"
					description="This will regenerate the invite message, overriding the current one. Are you sure you want to continue?"
					title="Regenerate Invite Message"
					@cancel="dialog.regenerateDescription = false"
					@confirm="regenerateDescription"
			></confirm-dialog>
		</v-col>
	</v-row>

</template>

<script>

import { Place } from '../../../helpers';
import * as _ from 'lodash';
import ConfirmDialog from '../../../UI/ConfirmDialog.vue';
import SequenceForm from './SequenceForm.vue';

export default {
	name: "Sequences",
	components: {
		ConfirmDialog,
		SequenceForm
	},
	props: {
		partner: {
			type: Object,
			default: () => ({})
		},
		pass: {
			type: Object,
			default: () => ({})
		},
		places: {
			type: Array,
			default: () => []
		},
		user: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			dialog: {
				message: false,
				regenerateDescription: false,
				sendTest: false,
				sendTestSuccess: false
			},
			dripSequencesLoading: true,
			dripSequenceDescriptions: [
				'View the emails that will be sent to the places invited to join this pass.',
				'If a merchant signs in but doesn’t complete their onboarding the following emails will be sent to them.'
			],
			dripSequenceFirstIntervals: [
				'Send this email at start date',
				'Send this email when the onboarding begins'
			],
			dripSequenceTitles: [
				'Place Invite Campaign',
				'Place Re-Engagement Campaign'
			],
			editingMessage: {
				drip: null,
				dripIdx: null,
				interval: null,
				isNew: false,
				isPreview: null,
				message: null,
				period: null,
				prevInterval: 0,
				sequenceIdx: null,
				subject: null
			},
			formIsValid: {
				campaignStatus: false,
				inviteDetails: false,
				sequenceActivation: false,
				viewCampaignEmails0: false,
				viewCampaignEmails1: false,
				message: false
			},
			isGeneratingDescription: false,
			isSaving: false,
			localCampaigns: [...this.pass.campaigns],
			localPass: this.pass,
			localPlaces: [],
			localDripSequences: [],
			localDripSequencesPreview: [],
			period: 'day',
			periodItems: [
				{ text: 'Select One', value: '', disabled: true },
				{ text: 'Minutes', value: 'minute'},
				{ text: 'Hours', value: 'hour'},
				{ text: 'Days', value: 'day'}
			],
			rules: {
				delay: [
					v => !!v || 'Delay before sending is required.',
					v => parseInt(v) > 0 || 'Delay must be greater than 0.',
				],
				description: [
					v => !!v || 'Campaign description is required.',
					v => v && v.length <= 2000 || 'Description must be less than 2000 characters',
				],
				email_subject: [v => !!v || 'Subject is required.'],
				message: [v => !!v || 'Message is required.'],
				period: [v => !!v || 'Delay period is required.']
			},
			testingCampaign: {
				email: null,
				idx: null
			}
		};
	},
	async mounted() {
		this.places.forEach(place => this.localPlaces.push(new Place(place)));

		const dripSequences = this.localCampaigns[0]?.email_settings?.dripSequences?.length > 0
			? _.cloneDeep(this.localCampaigns[0].email_settings.dripSequences)
			: [];
		if(dripSequences.length > 2) {
			dripSequences.pop();
		}

		this.localDripSequences = dripSequences;
		this.period = dripSequences?.[0]?.drips?.[1].period;

		this.getDripSequencesPreview();
	},
	computed: {
		endCampaignDate() {
			if(this.localCampaigns[0]?.inactivation_date && this.localCampaigns[0].inactivation_date !== '0000-00-00 00:00:00') {
				return moment(this.localCampaigns[0].inactivation_date).format('YYYY-MM-DD')
			}
			else if(this.localCampaigns[0]?.end_date && this.localCampaigns[0].end_date !== '0000-00-00 00:00:00') {
				return moment(this.localCampaigns[0].end_date).format('YYYY-MM-DD');
			}
			else {
				return 'N/A';
			}
		},
		globalPeriod: {
			get() {
				return this.period;
			},
			set(value) {
				this.localDripSequences.forEach(({ drips }) => {
					drips.forEach(mail => mail.period = value);
				});

				// never assign day to the first email period
				if (value === 'day') {
					this.localDripSequences[0].drips[0].period = 'hour';
				};

				this.period = value;
				this.saveSequences();
			}
		},
		periodLabel() {
			const label = this.globalPeriod.charAt(0).toUpperCase() + this.globalPeriod.slice(1);
			return `${label}s Before Sending`;
		},
		showPeriodSelector() {
			return this.user.is_admin && this.$bwFeatures.sequence_period_units_selector;
		}
	},
	methods: {
		doContinue() {
			window.location = `/partner-portal/${this.partner.id}/passes/${this.localPass.id}/invites`;
		},

		addMessage(sequenceIdx) {
			const drip = {
				active: true,
				delta: '1',
				interval: '',
				message: { message: '', subject: '' },
				period: this.globalPeriod
			};

			const { drips } = this.localDripSequences[sequenceIdx];
			drip.interval = drips.length
				? parseInt(drips[drips.length-1].interval) + 1
				: 0;
			const prevInterval = drips[drips.length - 1].interval;

			drips.push(drip);

			this.editingMessage.dripIdx = drips.length - 1;
			this.editingMessage.drip = drip;
			this.editingMessage.isNew = true;
			this.editingMessage.isPreview = false;
			this.editingMessage.period = this.globalPeriod;
			this.editingMessage.prevInterval = prevInterval;
			this.editingMessage.sequenceIdx = sequenceIdx;
			this.dialog.message = true;

			this.$nextTick(() => {
				this.$refs.formMessage.resetValidation();
			});
		},

		doSendTest() {
			const test = {
				sequenceIndex: this.testingCampaign.idx,
			}

			this.dialog.sendTest = false;
			this.isSaving = true;

			const url = `/partner-portal/${this.partner.id}/passes/send-test-sequence/${this.localCampaigns[0].id}`;

			axios.put(url, test)
					.then(({ data }) => {
						this.dialog.sendTestSuccess = true;
					})
					.catch(error => {
						window.EventBus.$emit('system-messages', [
							{ message: error.message, messageType: 'error' }
						]);
					})
					.finally(() => {
						this.isSaving = false;
					});
		},

		editMessage(sequenceIdx, dripIdx) {
			const drip = this.localDripSequences[sequenceIdx].drips[dripIdx];
			const { interval, message, period } = drip;
			const prevInterval = dripIdx > ( sequenceIdx === 0 ? 1 : 0)
				? this.localDripSequences[sequenceIdx].drips[dripIdx-1].interval
				: 0;

			this.dialog.message = true;

			this.editingMessage.delta = parseInt(interval) - parseInt(prevInterval);
			this.editingMessage.drip = drip;
			this.editingMessage.dripIdx = dripIdx;
			this.editingMessage.interval = interval;
			this.editingMessage.isPreview = false;
			this.editingMessage.message = message.message;
			this.editingMessage.period = period;
			this.editingMessage.prevInterval = prevInterval;
			this.editingMessage.sequenceIdx = sequenceIdx;
			this.editingMessage.subject = message.subject;
		},

		exit() {
			window.location.href = `/partner-portal/${this.partner.id}/passes`;
		},

		async getDripSequencesPreview() {
			const { localDripSequences } = this;
			let dripSequences;

			if(localDripSequences.length > 0) {
				//Replace the variables on all messages
				try {
					const url = `/partner-portal/${this.partner.id}/passes/get-drip-sequences-message-contents`;
					const response = await axios.post(url, {
						dripSequences: localDripSequences,
						dealId: this.pass.id,
						campaignId: this.localCampaigns[0]?.id,
						venueId: this.localPlaces[0]?.id,
						launchDate: this.pass.launch_date,
						endDate: this.localCampaigns[0]?.end_date,
					});
					dripSequences = response.data.dripSequences;

					//add the 'Email n:' legend to each subject
					let emailIdx = 1;
					dripSequences.forEach((dripSequence, idx) => {
						dripSequence.drips.forEach(drip => {
							if(drip.message?.subject) {
								this.$set(drip.message, 'index', emailIdx++);
							}
						});
						emailIdx = 1;
					});
				}
				catch (error) {
					window.EventBus.$emit('system-messages', [
						{ message: error.message, messageType: 'error' }
					]);
				}
			}
			this.dripSequencesLoading = false;
			this.localDripSequencesPreview = dripSequences;
		},

		showMessagePreview(message) {
			this.dialog.message = true;

			this.editingMessage.isPreview = true;
			this.editingMessage.message = message.message;
			this.editingMessage.subject = message.subject;
		},

		hideMessagePreview() {
			this.dialog.message = false;
			const { editingMessage: { sequenceIdx, isNew } } = this;

			if (isNew) {
				const { drips } = this.localDripSequences[sequenceIdx];
				drips.pop();
			}

			Object.keys(this.editingMessage).forEach(key => {
				this.editingMessage[key] = null;
			});
		},

		regenerateDescription() {
			this.isSaving = true;
			this.isGeneratingDescription = true;

			const { localCampaigns: campaigns, pass } = this;

			const url = `/partner-portal/${this.partner.id}/passes/regenerate-campaign-description/${this.localPass.id || ''}`;

			axios.put(url, { pass, campaigns })
					.then(({ data }) => {
						campaigns[0].description = data.description;
						window.EventBus.$emit('system-messages', [
							{
								message: 'Invite message regenerated successfully.',
								messageType: 'success',
								timeout: 2000
							}
						]);
					})
					.catch(error => {
						window.EventBus.$emit('system-messages', [
							{ message: error.message, messageType: 'error' }
						]);
					})
					.finally(() => {
						this.isSaving = false;
						this.isGeneratingDescription = false;
						this.dialog.regenerateDescription = false
					});
		},

		regenerateDescriptionDialog() {
			this.dialog.regenerateDescription = true;
		},

		save() {
			if (this.localCampaigns?.[0]?.email_settings?.dripSequences) {
				this.localCampaigns[0].email_settings.dripSequences[0] = this.localDripSequences[0];
				this.localCampaigns[0].email_settings.dripSequences[1] = this.localDripSequences[1];
			}

			this.editingMessage.isNew = null;

			const {
				editingMessage: {
					drip,
					dripIdx,
					delta,
					interval: oldInterval,
					message,
					period,
					prevInterval,
					sequenceIdx,
					subject
				}
			} = this;

			drip.interval = parseInt(delta) + parseInt(prevInterval);
			drip.message.message = message;
			drip.message.subject = subject;
			drip.period = period;

			// update upstream drip intervals
			const shift = drip.interval - parseInt(oldInterval);
			const drips = this.localDripSequences[sequenceIdx].drips;
			const upstreamDrips = drips.slice(dripIdx + 1);
			upstreamDrips.map( drip => drip.interval = parseInt(drip.interval) + shift);

			this.isSaving = true;
			const url = `/partner-portal/${this.partner.id}/passes/save-campaigns/${this.localPass.id || ''}`;

			axios.put(url, { pass: this.pass, campaigns: this.localCampaigns })
					.then(response => this.getDripSequencesPreview())
					.catch(error => {
						this.isSaving = false;
						window.EventBus.$emit('system-messages', [
							{ message: error.message, messageType: 'error' }
						]);
					})
					.finally(() => {
						this.isSaving = false;
						this.hideMessagePreview();
					});
		},

		saveActiveChange(sequenceIdx, dripIdx, active) {
			this.localDripSequences[sequenceIdx].drips[dripIdx].active = active;
			this.saveSequences();
		},

		saveSequences(){
			const campaigns = [
				{
					active: true,
					id: this.localCampaigns[0].id,
					email_settings: {
						dripSequences: [
							this.localDripSequences[0],
							this.localDripSequences[1]
						]
					}
				}
			]

			this.isSaving = true;
			const url = `/partner-portal/${this.partner.id}/passes/save-campaigns/${this.localPass.id || ''}`;

			axios.put(url, { campaigns })
					.then(({ data }) => {})
					.catch(error => {
						window.EventBus.$emit('system-messages', [
							{ message: error.message, messageType: 'error' }
						]);
					})
					.finally(() => {
						this.isSaving = false;
					});
		},
		sendTest(sequenceIdx) {
			this.testingCampaign.idx = sequenceIdx;
			this.testingCampaign.email = '';
			this.dialog.sendTest = true;
		}
	}
}

</script>
<style scoped>
.email-preview.v-card:first-child > .v-card__actions::after {
    height: 0;
}
</style>
<style>
.send-test .v-card__actions {
	margin-top: -24px;
}
</style>
